module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-c471db62b742da2bd038f4d0acae061b.png";